import { ITransactionsDistinctRecipientsState } from './types';

export const initialState: ITransactionsDistinctRecipientsState = {
  isLoading: false,
  error: null,
  data: null,
};
